var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Radio, Label } from 'flowbite-react';
import { isString } from 'lodash';
import { Translate } from "../../../I18N";













const RadioSelect = ({
  legend,
  options,
  name,
  onChange,
  className,
  orientation = 'vertical'
}) => /*#__PURE__*/
_jsx("fieldset", {
  className: `flex flex-wrap gap-4 ${
  orientation === 'vertical' ? 'flex-col max-w-md' : ''} ${
  className}`,
  id: `radio_${name}` }, void 0,

legend && /*#__PURE__*/_jsx("legend", { className: "mb-4" }, void 0, legend),
options.map((option) => /*#__PURE__*/
_jsx("div", {
  className: `flex items-center gap-2 ${orientation === 'vertical' ? '' : 'mr-4'}` },
option.id || option.value, /*#__PURE__*/

_jsx(Radio, {
  id: `${name}_${option.value}`,
  name: name,
  value: option.value,
  disabled: option.disabled || false,
  defaultChecked: option.defaultChecked,
  onChange: onChange }
), /*#__PURE__*/
_jsx(Label, {
  htmlFor: `${name}_${option.value}`,
  className: `cursor-pointer ${option.disabled ? '!text-gray-300' : ''}` }, void 0,

isString(option.label) ? /*#__PURE__*/_jsx(Translate, {}, void 0, option.label) : option.label
)
)
)
);



export { RadioSelect };